import { TOOL_NAME_TO_ICON_MAPPING } from '@/shared/config';
import type { IconNames } from '@/shared/ui';

import {
  MPR_TOOLS_BY_MODE_MAP,
  type MPRAnnotationTool,
  type MPRImageTool,
  type MPRInputMode,
} from '@/features/MPR';

import { FULL_HEAD_MPR_IMAGE_TOOL_ICONS } from '../config';

// The icon shown next to the cursor over a pane; null for the plain
// navigation mode, where the crosshair cursor already says what a click does.
export const resolveFullHeadMprCursorIcon = ({
  activeMode,
  annotationTool,
  imageTool,
}: {
  activeMode: MPRInputMode;
  annotationTool: MPRAnnotationTool | null;
  imageTool: MPRImageTool | null;
}): IconNames | null => {
  if (annotationTool) {
    return TOOL_NAME_TO_ICON_MAPPING[annotationTool];
  }

  if (imageTool) {
    return FULL_HEAD_MPR_IMAGE_TOOL_ICONS[imageTool];
  }

  return activeMode === 'mainMode' ? null : MPR_TOOLS_BY_MODE_MAP[activeMode];
};
